/**
 * Planning Pool API Client (Epic D-1 — Fundament, Story D-1.4)
 *
 * AD-9: `lib/<resource>Api.ts`-conventie, zelfde vorm als
 * `planningCapacityApi.ts`. Praat met de planbaarheidsroutes van D-1.4
 * (`/api/v1/planning/pool`): de stand per medewerker (automatisch/handmatig)
 * en de handmatige schakelaar.
 */

import { apiRequest } from './api';
import type {
  PlanningPoolOverrideDTO,
  PlanningPoolStatusDTO,
  SetPlanningPoolOverrideInput,
} from '@functieloonhuis/shared';

interface DataResponse<T> {
  data: T;
}

export const planningPoolApi = {
  /** GET /planning/pool?date= — de planbaarheid van élke medewerker op die datum. */
  listStatus: async (date: string): Promise<PlanningPoolStatusDTO[]> => {
    const res = await apiRequest<DataResponse<PlanningPoolStatusDTO[]>>(
      `/planning/pool?date=${encodeURIComponent(date)}`
    );
    return res.data;
  },

  /** PUT /planning/pool/:employeeId — body `{ isPlanbaar, reason }` (reden verplicht). */
  setOverride: async (
    employeeId: number,
    input: SetPlanningPoolOverrideInput
  ): Promise<PlanningPoolOverrideDTO> => {
    const res = await apiRequest<DataResponse<PlanningPoolOverrideDTO>>(
      `/planning/pool/${employeeId}`,
      {
        method: 'PUT',
        body: JSON.stringify(input),
      }
    );
    return res.data;
  },

  /** DELETE /planning/pool/:employeeId — heft de handmatige stand op. */
  clearOverride: async (employeeId: number): Promise<void> => {
    await apiRequest<void>(`/planning/pool/${employeeId}`, { method: 'DELETE' });
  },
};
